// extracted by mini-css-extract-plugin
export default {"container":"pZmzo","title":"Q8Mqt","comments":"vrYqM"};